import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ROUTES } from './routeConstants';

interface EventRedirectProps {
  action?: 'cancel';
}

/**
 * Redirects /events/:eventId and /events/:eventId/cancel to the dashboard
 * with appropriate query parameters so the bookings dashboard can open the
 * event details panel or cancel dialog.
 */
export const EventRedirect = ({ action }: EventRedirectProps) => {
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams();
    if (eventId) params.set('eventId', eventId);
    if (action) params.set('action', action);
    void navigate(`${ROUTES.BOOKINGS}?${params.toString()}`, { replace: true });
  }, [eventId, action, navigate]);

  return null;
};
